export interface IUserNameParts {
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
}

/**
 * Builds the user's display name as `${preferredName || firstName} ${lastName}`,
 * dropping any null/undefined/empty-string components. Returns null when no parts
 * remain. `||` (not `??`) so an empty-string `preferredName` falls back to `firstName`.
 */
export default function formatUserDisplayName(user: IUserNameParts): string | null {
  const first = user.preferredName || user.firstName;
  const parts = [first, user.lastName].filter((part): part is string => Boolean(part));
  return parts.length > 0 ? parts.join(' ') : null;
}
